import { useWarningLayerData } from "../../api/matlocq/warning-layer-data/useWarningLayerData";
import { useLayerDataQuery } from "../../api/w3/useLayerDataQuery";
import { useStable } from "../../common/hooks/useStable";
import { useLayers } from "../../config/layers/useLayers";
import type { LayerData } from "./types";

export function useLayerDataForActiveWorldRegion(): {
    isLoading: boolean;
    isError: boolean;
    layerData: LayerData;
} {
    const { shownLayers, isLayerShown } = useLayers();

    const { isError, shownLayersData, isLoading } = useLayerDataQuery(
        shownLayers.filter(
            (layerName) =>
                layerName === "precipitation" ||
                layerName === "clouds" ||
                layerName === "wind" ||
                layerName === "windGust",
        ),
    );

    const {
        data: warningLayerData,
        isLoading: warningLayerDataIsLoading,
        error: warningLayerDataError,
    } = useWarningLayerData(!isLayerShown("warnings"));

    const layerData: LayerData = {
        ...shownLayersData,
        ...(!warningLayerDataIsLoading && warningLayerData !== undefined
            ? {
                  warnings: warningLayerData,
              }
            : {}),
    };

    return useStable({
        layerData,
        isLoading: isLoading || warningLayerDataIsLoading,
        isError: isError || warningLayerDataError !== undefined,
    });
}
